import { USAStateEnum } from '@trp/community/auth/interfaces';
import { MenuDefinition } from './menu.model';

export const DEFAULT_MENU_CONFIG: MenuDefinition = {
  items: [
    { link: 'notifications',
      text: 'navigation.default.notifications',
      icon: 'notifications',
      onlyVerified: true,
    },
    { link: 'home', text: 'navigation.default.home', icon: 'home' },
    { link: 'map', text: 'navigation.default.recyclingMap', icon: 'map' },
    {
      link: 'recommendation',
      text: 'navigation.default.recommendations',
      icon: 'diversity_3',
      onlyVerified: true,
    },
    {
      link: 'program-metrics',
      text: 'navigation.default.yourProgramMetrics',
      icon: 'insert_chart_outlined',
      onlyVerified: true,
    },
    {
      link: 'drop-off-locations',
      text: 'navigation.default.dropOffLocations',
      icon: 'location_on',
      onlyCommunityManager: true,
      // onlyAdmin: true
    },
    {
      link: 'educational-materials',
      text: 'navigation.default.printMaterials',
      icon: 'article',
    },
    {
      link: 'resource',
      text: 'navigation.default.resources',
      icon: 'folder_open',
    },
    {
      link: 'https://csbi.thinkific.com/',
      text: 'navigation.default.courseCatalog',
      icon: 'library_books',
      external: true,
    },
    {
      link: 'glossary',
      text: 'navigation.default.glossary',
      icon: 'menu_book',
    },
    {
      link: 'faq',
      text: 'navigation.default.faq',
      icon: 'live_help',
      onlyVerified: true,
    },
    {
      link: 'contact-us',
      text: 'navigation.default.contactUs',
      icon: 'contact_support',
      pinnedBottom: true,
    },
  ],
};

export const OREGON_MENU_CONFIG: MenuDefinition = {
  disableTopbar: true,
  items: [
    { link: 'notifications',
      text: 'navigation.oregon.notifications',
      icon: 'notifications',
      onlyVerified: true,
    },
    { link: 'home', text: 'navigation.oregon.home', icon: 'home' },
    {
      link: 'recommendation',
      text: 'navigation.oregon.recommendations',
      icon: 'diversity_3',
      onlyVerified: true,
    },
    {
      link: 'program-metrics',
      text: 'navigation.oregon.yourProgramMetrics',
      icon: 'insert_chart_outlined',
      onlyVerified: true,
    },
    {
      link: 'drop-off-locations',
      text: 'navigation.oregon.dropOffLocations',
      icon: 'location_on',
      onlyCommunityManager: true,
      // onlyAdmin: true
    },
    {
      link: 'educational-materials',
      text: 'navigation.oregon.printMaterials',
      // icon: 'picture_as_pdf',
      icon: 'article',
    },
    {
      link: 'https://csbi.thinkific.com/',
      text: 'navigation.oregon.courseCatalog',
      icon: 'library_books',
      external: true,
    },
    {
      link: 'resource',
      text: 'navigation.oregon.otherResources',
      icon: 'folder_open',
    },
    { link: 'map', text: 'navigation.oregon.recyclingMap', icon: 'map' },
    {
      link: 'glossary',
      text: 'navigation.oregon.glossary',
      icon: 'menu_book',
    },
    {
      link: 'faq',
      text: 'navigation.oregon.faq',
      icon: 'live_help',
      onlyVerified: true,
    },
  ],
};

export const COLORADO_MENU_CONFIG: MenuDefinition = {
  disableTopbar: true,
  items: [
    { link: 'notifications', text: 'navigation.colorado.notifications', icon: 'notifications', onlyVerified: true },
    { link: 'home', text: 'navigation.colorado.home', icon: 'home' },
    { link: 'recommendation', text: 'navigation.colorado.recommendations', icon: 'diversity_3', onlyVerified: true },
    { link: 'program-metrics', text: 'navigation.colorado.yourProgramMetrics', icon: 'insert_chart_outlined', onlyVerified: true },
    { link: 'drop-off-locations', text: 'navigation.colorado.dropOffLocations', icon: 'location_on', onlyCommunityManager: true },
    { link: 'educational-materials', text: 'navigation.colorado.printMaterials', icon: 'article' },
    { link: 'https://csbi.thinkific.com/', text: 'navigation.colorado.courseCatalog', icon: 'library_books', external: true },
    { link: 'resource', text: 'navigation.colorado.otherResources', icon: 'folder_open' },
    { link: 'map', text: 'navigation.colorado.recyclingMap', icon: 'map' },
    { link: 'glossary', text: 'navigation.colorado.glossary', icon: 'menu_book' },
    { link: 'faq', text: 'navigation.colorado.faq', icon: 'live_help', onlyVerified: true },
  ],
};

export const STATE_MENU_CONFIGS: Partial<Record<USAStateEnum, MenuDefinition>> =
  {
    [USAStateEnum.Oregon]: OREGON_MENU_CONFIG,
    [USAStateEnum.Colorado]: COLORADO_MENU_CONFIG,
  };
